module.exports = __webpack_public_path__ + "img/logo.05449d69.png";